import React, { useEffect, useState } from 'react';

export default function App() {
  const [msgs, setMsgs] = useState([]);

  useEffect(() => {
    // 1) Load full history and dedupe
    fetch('/messages')
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(history => {
        const seen = new Set();
        const unique = [];
        history.forEach(m => {
          const key = `${m.channel}-${m.id}`;
          if (!seen.has(key)) {
            seen.add(key);
            unique.push(m);
          }
        });
        setMsgs(unique);
      })
      .catch(err => console.error('History load error', err));

    // 2) Open WebSocket on same origin
    const proto = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const wsUrl = `${proto}://${window.location.host}`;
    console.log('Connecting to', wsUrl);
    const ws = new WebSocket(wsUrl);

    ws.onopen    = () => console.log('✅ WS connected');
    ws.onerror   = e  => console.error('❌ WS error', e);
    ws.onmessage = e  => {
      const msg = JSON.parse(e.data);
      const key = `${msg.channel}-${msg.id}`;
      setMsgs(prev => {
        // skip if we've already seen this message
        if (prev.some(m => `${m.channel}-${m.id}` === key)) {
          return prev;
        }
        return [msg, ...prev];
      });
    };

    return () => ws.close();
  }, []);

  return (
    <div style={{ maxWidth: 800, margin: '2rem auto', fontFamily: 'Arial, sans-serif' }}>
      <header style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <h1 style={{ fontSize: '2.5rem', margin: 0 }}>📡 Telegram Live Scraper</h1>
      </header>

      {msgs.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#666' }}>No messages yet…</p>
      ) : (
        msgs.map(m => (
          <div
            key={`${m.channel}-${m.id}`}
            style={{
              marginBottom: '1.5rem',
              padding: '1rem',
              border: '1px solid #eee',
              borderRadius: '4px'
            }}
          >
            <div style={{ fontSize: '0.85rem', color: '#999' }}>
              {new Date(m.date).toLocaleString()}
            </div>
            <div style={{ marginTop: '0.5rem', fontSize: '1rem' }}>
              <strong>{m.channel}</strong>: {m.text}
            </div>
          </div>
        ))
      )}
    </div>
  );
}
